import { render } from "./AvatarCropper.vue?vue&type=template&id=80fa9f3a"
import script from "./AvatarCropper.vue?vue&type=script&lang=js"
export * from "./AvatarCropper.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__